var React = require('react');

function EllipsisHAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M80 184a72 72 0 1 0 72 72 72 72 0 0 0-72-72zm0 96a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm352-96a72 72 0 1 0 72 72 72 72 0 0 0-72-72zm0 96a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm-176-96a72 72 0 1 0 72 72 72 72 0 0 0-72-72zm0 96a24 24 0 1 1 24-24 24 24 0 0 1-24 24z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M80 232a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm176 0a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm176 0a24 24 0 1 0 24 24 24 24 0 0 0-24-24z","className":"fa-primary","key":2})]);
}

EllipsisHAlt.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = EllipsisHAlt;

EllipsisHAlt.default = EllipsisHAlt;
